import { render, staticRenderFns } from "./RawContact.vue?vue&type=template&id=0410b71e"
import script from "./RawContact.vue?vue&type=script&lang=js"
export * from "./RawContact.vue?vue&type=script&lang=js"
import style0 from "./RawContact.vue?vue&type=style&index=0&id=0410b71e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports